import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { ATCCode } from "../../../Data/Art57Data/ATCCode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeATCCodeType extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new ATCCode(new FieldDefinition(injector)),
              '{param1}{param2}{param3}{param4}'
      );
  
      this.parent = parent;
      this.labelNodeName = 'ATC Code';
      this.data.model.operationtype = 1;
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {
      const param1 = this.ioc!.get(LookupGetService).retrieveValueFromCache('operationtype',this.data.model.operationtype);
      let param2 = '';
      let param3 = '';
      let param4 = '';

      if (this.data && this.data.model && this.data.model.type_Term) {
        param2 = ' - ' +  this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'type_Term',
          this.data.model.type_Term
        ); 
      }

      if (this.data && this.data.model && this.data.model.atccode) {
        param3 = ' - ' + this.data.model.atccode; 
      }

      if (this.data && this.data.model && this.data.model.atccode_Desc) {
        param4 = ' - ' + this.data.model.atccode_Desc; 
      }
         
      this.label = this.labelTemplate
                                      .replace('{param1}',param1)
                                      .replace('{param2}',param2)
                                      .replace('{param3}',param3)
                                      .replace('{param4}',param4);
    }
  
    override getListItem(): any[] {
      return [
        this.data.model && this.data.model.operationtype
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'operationtype',
            this.data.model.operationtype
          )
          : '-',
        this.data.model && this.data.model.type_Term
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'type_Term',
            this.data.model.type_Term
          )
          : '-',
        this.data.model && this.data.model.atccode
          ? this.data.model.atccode
          : 'ATC Code',
        '',
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeATCCodeType = new TreeNodeATCCodeType(
        this.ioc!,
        newParent
      );
  
      const currentLocalNumber = this.ioc!.get(LookupGetService).getNodeLocalNumber(clonedNode, this);
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.data.model.localnumber = currentLocalNumber;
      this.ioc!.get(LookupGetService).fixLocalNumber(clonedNode.data.model.localnumber);
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
  
      return clonedNode;
    }

    override validateBusinessRules(): any[] {

      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];
      
      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
    }
  }
  